/* src/app/shared/layout/ag-tree-v2/ag-tree-v2-node/ag-tree-v2-node.component.scss */
.ag-tree-node {
  border-radius: 16px;
  border-top: 1px solid #f1f1f1;
}
.ag-tree-node :hover {
  background-color: #f9f9f9;
  cursor: pointer;
}
.ag-tree-node .row-container {
  height: 70px;
  padding: 0px 30px;
}
.ag-tree-node.open {
  border-bottom: 1px solid #f1f1f1;
}
.ag-tree-content {
  margin-left: 24px;
  margin-right: 24px;
}
.ag-tree-content-background {
  border-top: 1px solid #dfdfdf;
  background-color: #f2f2f2;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}
.agDescription {
  font-size: 13px;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  color: #adadad;
}
.agTitle {
  font-size: 16px;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #333333;
}
.agDate {
  padding-right: 48px;
}
.agItems {
  padding-right: 32px;
  font-size: 13px;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  color: #adadad;
}
.node-toggle {
  min-width: 30px;
  height: 30px;
  border-radius: 15px;
  margin-left: 8px;
}
.node-toggle:hover {
  transition: all 200ms ease-in;
  background-color: rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=ag-tree-v2-node.component.css.map */
